import { DatePicker, LocalizationProvider, ptBR } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useValidateSchema } from '../../../../hooks/providers/useValidateSchema';
import { useWizardRequest } from '../../../../hooks/services/useWizardRequest';
import IFormError from '../../../../interfaces/IFormError';
import IWizardStep from '../../../../interfaces/IWizardStep';
import WizardButton from '../../components/WizardButton';
import { WizardContent } from '../../components/WizardContent';
import { WizardSecodaryTitle } from '../../components/WizardSecodaryTitle';
import { WizardTitle } from '../../components/WizardTitle';
import * as yup from 'yup';
import { useToastrVanila } from '../../../../hooks/util/useToastrVanila';
import WizardTextField from '../../components/WizardTextField';

interface DocumentDateProps extends IWizardStep {}

const DocumentDate = (props: DocumentDateProps) => {
  const wizardService = useWizardRequest();
  const [loading, setLoading] = useState(false);
  const [documentDesctipion, setDocumentDescription] = useState('');
  const [errors, setErrors] = useState<IFormError>();
  const [documentDate, setDocumentDate] = useState<moment.Moment | null>(moment(props.medicalCertificate.documentDate));
  const validationProvader = useValidateSchema();
  const toastr = useToastrVanila();
  const request = useWizardRequest();

  const dateValidation = (date: string, schema: yup.TestContext): yup.ValidationError | boolean => {
    if (!date) {
      return schema.createError({ message: `Campo obrigatório` });
    }
    if (date === 'null') {
      return schema.createError({ message: `Campo obrigatório` });
    }

    if (date === 'Invalid date') {
      return schema.createError({ message: `Data inválida` });
    }

    if (moment(date).format('YYYY-MM-DD') > moment().format('YYYY-MM-DD')) {
      return schema.createError({ message: `A data do documento deve ser igual ou menor que a data atual` });
    }
    return true;
  };

  const schema = yup.object({
    documentDate: yup
      .string()
      .nullable(true)
      .test((date, schema) => dateValidation(`${date}`, schema)),
  });

  const loadTypeDocuments = async () => {
    const queryParams = `perPage=200&currentPage=1&orderBy=description&orderDirection=asc`;
    await wizardService
      .listTypeDocuments(queryParams)
      .then(response => {
        const document = response?.data?.find(document => document.id === props.medicalCertificate.typeDocumentId);
        setDocumentDescription(`${document?.description}`);

        setLoading(false);
      })
      .catch(error => {
        setLoading(false);
        toastr.error('Houve um problema ao carregar os dados da página. Tente novamente mais tarde');
      });
  };
  useEffect(() => {
    setDocumentDescription(props.medicalCertificate.typeDocument?.description!);

    loadTypeDocuments();
  }, []);

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    const result = await validationProvader.validate(schema, { documentDate });
    setErrors({ ...result.errors });
    if (!result.isValid) {
      return;
    }
    setLoading(true);

    const isOverlaped = await request.isOverlap(props.medicalCertificate.employeeId, String(documentDate));

    if (isOverlaped) {
      await props.setStep(props.step + 7, {
        ...props.medicalCertificate,
        errorTitle: 'Sobreposição de Período',
        errorMessage:
          'Existe um documento vigente neste período. Por favor, confirme se a data do documento está correta.',
      });
    } else {
      await props.setStep(props.step + 1, {
        ...props.medicalCertificate,
        documentDate: `${documentDate?.format('yyyy-MM-DD HH:mm:ss')}`,
        startTime: `${documentDate?.format('yyyy-MM-DD HH:mm:ss')}`,
        endTime: `${documentDate?.format('yyyy-MM-DD HH:mm:ss')}`,
      });
    }
  };

  return (
    <WizardContent>
      <WizardTitle marginBotton={2}>Informe a Data do Documento</WizardTitle>
      <WizardSecodaryTitle>({documentDesctipion})</WizardSecodaryTitle>
      <form onSubmit={handleSubmit}>
        <LocalizationProvider
          dateAdapter={AdapterMoment}
          localeText={ptBR.components.MuiLocalizationProvider.defaultProps.localeText}
        >
          <DatePicker
            value={documentDate}
            label="Data do documento"
            onChange={e => {
              setDocumentDate(e);
            }}
            renderInput={params => (
              <WizardTextField
                {...params}
                sx={{ marginTop: '30px', width: '275px' }}
                size="small"
                error={Boolean(errors?.documentDate)}
                placeholder="Data do documento"
                helperText={errors?.documentDate}
                autoFocus
              />
            )}
          />
        </LocalizationProvider>
        <WizardButton type="submit" isLoading={loading} disabled={loading} sx={{ marginTop: '100px' }}>
          PRÓXIMO
        </WizardButton>
      </form>
    </WizardContent>
  );
};

export default DocumentDate;
